<template>
  <div class="homeWrap">
      <router-view v-if="isRouterAlive"/>
  </div>
</template>

<script>
export default {
  name: 'datavFrame',
  data () {
    return {
      isRouterAlive: true,
    }
  },
  provide() {
    return {
      reload: this.reload
    }
  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.homeWrap {
  height: 100%;
  box-sizing: border-box;
}
</style>



// WEBPACK FOOTER //
// src/pages/capacity/frame.vue